export default "__VITE_ASSET__BGUXTYqg__"